"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _variants = _interopRequireDefault(require("../Button/variants"));
var _types = require("./types");
function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var primary = _variants.default.primary;
var secondary = _variants.default.secondary;
// TODO: Remove contrast variant and replace with: variantType.
var contrast = function contrast($variantType) {
  var buttonStyle = _variants.default.outlineTransparent($variantType);
  switch ($variantType) {
    case _types.IconButtonVariantTypes.Default:
      return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                ", ";\n\n                background-color: #fff;\n                border-color: ", ";\n                &:focus {\n                    box-shadow: none;\n                }\n            \n                &:disabled {\n                    background-color: ", ";\n                    border-color: ", ";\n                }\n            \n            "], ["\n                ", ";\n\n                background-color: #fff;\n                border-color: ", ";\n                &:focus {\n                    box-shadow: none;\n                }\n            \n                &:disabled {\n                    background-color: ", ";\n                    border-color: ", ";\n                }\n            \n            "])), buttonStyle, function (_a) {
        var theme = _a.theme;
        return theme.colors.grey[4];
      }, function (_a) {
        var theme = _a.theme;
        return theme.colors.grey[4];
      }, function (_a) {
        var theme = _a.theme;
        return theme.colors.grey[4];
      });
  }
};
var outline = _variants.default.outline;
var variants = {
  primary: primary,
  secondary: secondary,
  outline: outline,
  contrast: contrast
};
var _default = variants;
exports.default = _default;
var templateObject_1;